import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabGroupComponent } from './tab-group.component';

@NgModule({
  declarations: [
    TabGroupComponent
  ],
  exports: [
    TabGroupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class TabGroupModule { }
